import React from "react";
import { Affix, Button, Col, Row } from "antd";
import AddLicenceeFields from "./AddLicenceeFields";
import { IconArrowLeft } from "../../../../../common/ui/icons";

const AddLicenseeForm = ({ form, name, ...rest }) => {
  const handleFormSubmit = () => {
    rest.handleMediumFormSubmit(name);
  };
  return (
    <div id="addLicensee" className="basicForm">
      <Row type="flex" justify="space-between" gutter={16}>
        <Col span={18}>
          <div className="formContainer">
            <AddLicenceeFields
              form={form}
              handleFieldsChange={rest.handleFieldsChange}
              data={rest.data}
            />
          </div>
        </Col>
        <Col span={6}>
          <Affix
            offsetTop={18}
            target={() => document.getElementById("mainSheet")}
          >
            <div className="sidebarContainer">
              <div className="button">
                <Button
                  type="primary"
                  htmlType="submit"
                  onClick={handleFormSubmit}
                >
                  Далее
                </Button>
                <Button
                  style={{ marginTop: 20 }}
                  onClick={() => rest.history.goBack()}
                >
                  <IconArrowLeft />
                  Отмена
                </Button>
              </div>
            </div>
          </Affix>
        </Col>
      </Row>
    </div>
  );
};

export default AddLicenseeForm;
